import React from "react";
import Slider from "react-slick";
import "./carousel-sidebar.m.css";

const CarouselSidebar = ({ children, options }) => {
  function SampleNextArrow(props) {
    const { style, onClick, className } = props;
    return (
      <div styleName="right-arrow" className="right-arrow">
        <button onClick={onClick}>&#9650;</button>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div styleName="left-arrow" className="left-arrow">
        <button onClick={onClick}>&#9650;</button>
      </div>
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    centerPadding: "60px",
    swipeToSlide: true,
    dotsClass: "slick-dots slick-thumb",
    ...options,
  };

  return (
    <div>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};

export default CarouselSidebar;
